export const C__Form = () => ({
    init() {
        if (typeof acf !== 'undefined' && acf) {
            // console.log('ACF is loaded');
            acf.addAction('af/form/ajax/submission', (data, form) => {
                // console.log('Go to top of the form', form);

                // scroll to elem id
                this.scrollToForm(form);
            });
        }
    },

    scrollToForm(form) {
        // scroll to elem id with offset
        const elem = document.getElementById(form.key);
        const header = document.querySelector('.b--header'); // get the header element
        const offset = header.offsetHeight + 200; // get the height of the header

        const yPosition =
            elem.getBoundingClientRect().top + window.scrollY - offset;

        window.scrollTo({ top: yPosition, behavior: 'smooth' });
    }
});
